<template>
  <div
    class="py-4 container-fluid min-vh-100"
    :class="isDarkMode ? 'reg-page-dark' : 'bg-light-moniex'"
    :style="isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="reg-hero-banner mb-3"
      :style="isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="reg-hero-content">
        <h1
          :style="isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Dokončení registrace</h1>
        <p :style="isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">
          Jméno, kódy z e-mailu a SMS, heslo — a jsi v INGA.
        </p>
      </div>
    </div>

    <div class="row align-items-start">
      <div class="col-12 col-lg-4 mb-4 mb-lg-0">
        <RegisterConfirmationCard />
      </div>
      <div class="col-12 col-lg-4 mb-4 mb-lg-0">
        <div
          class="border-0 shadow-sm rounded-4 text-center position-relative mb-4 img-inga-card"
          :class="isDarkMode ? 'p-0' : 'p-3'"
          :style="isDarkMode
            ? 'background: #0F172A !important; border: none !important; box-shadow: none !important; border-radius: 0.65rem !important;'
            : 'background: #ffffff !important; border: none !important; border-radius: 0.65rem !important;'"
        >
          <div
            class="inga-speech-bubble"
            :class="{ 'inga-speech-bubble-dark': isDarkMode }"
          >
            „Pro dokončení registrace doplň svoje jméno a příjmení a zvol si heslo.“
          </div>
          <IngaPortrait :src="imgRoot + 'inga.jpg'" />
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <ActiveGamesSidebar />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import RegisterConfirmationCard from "./components/custom/RegisterConfirmationCard.vue";
import IngaPortrait from "./components/custom/IngaPortrait.vue";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
</script>
<style scoped>
.reg-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}
.reg-hero-content h1 {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}
.reg-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}
.reg-page-dark .reg-hero-banner {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}
.bg-light-moniex { background-color: #f8f9fa; }

.img-inga-card { margin-top: 4.5rem !important; border: none !important; border-radius: 0.65rem !important; }

.inga-speech-bubble {
  position: absolute !important;
  top: -80px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background-color: #ffffff !important;
  border: 2px solid #FF7A00 !important;
  color: #1E293B !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  padding: 10px 14px !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06) !important;
  z-index: 10 !important;
  width: 92% !important;
  max-width: 280px !important;
}
.inga-speech-bubble-dark {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}
.inga-speech-bubble::after, .inga-speech-bubble::before {
  content: ''; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); border-style: solid; display: block; width: 0;
}
.inga-speech-bubble::after { border-width: 10px 10px 0; border-color: #ffffff transparent transparent; z-index: 11; }
.inga-speech-bubble::before { bottom: -13px; border-width: 11px 11px 0; border-color: #FF7A00 transparent transparent; z-index: 9; }
.inga-speech-bubble-dark::after { border-color: #1E293B transparent transparent; }
</style>
